
import {
    TWEETS_CHANGE,
 } from '../../actions/types';
import { set } from 'react-ga';
 
 const initialState = {
     tweets: []
 };
 
 
 const setTweets = (state, action) => {
     let tweets = action.payload.tweets || [];
     return {
         ...state,
          tweets  
     }
 }
 
 
 export default (state = initialState, action) => {
     switch (action.type) {
         case TWEETS_CHANGE:
             return setTweets(state,action);
             break;
 
         default:
             return state;
             break;
     }
 }